import { Button } from '@/modules/shared/components/ui/button';
import {
  AppModal,
  AppModalDescription,
  AppModalFooter,
  AppModalHeader,
  AppModalTitle,
} from '@/modules/shared/components/ui/AppModal';

export interface ApprovalLinkStatusModalProps {
  open: boolean;
  title: string;
  message: string;
  actionLabel: string;
  onAction: () => void;
}

export function ApprovalLinkStatusModal({
  open,
  title,
  message,
  actionLabel,
  onAction,
}: ApprovalLinkStatusModalProps) {
  return (
    <AppModal open={open} onClose={onAction} size="default" preventBackdropClose>
      <AppModalHeader hideCloseButton>
        <AppModalTitle>{title}</AppModalTitle>
        <AppModalDescription>{message}</AppModalDescription>
      </AppModalHeader>
      <AppModalFooter>
        <Button type="button" className="h-8 text-[12px]" onClick={onAction}>
          {actionLabel}
        </Button>
      </AppModalFooter>
    </AppModal>
  );
}
